var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{ notconnected: _vm.serverState == 'unconnected' },attrs:{"id":"app"}},[[_vm._t("default")],(_vm.serverState === 'disconnected')?_c('Reconnect',{on:{"reconnect":_vm.connect}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }